import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '@common/common.action';
import * as actionsFiltros from '../filtros/filtro.action';
import WebapiCommon from '@common/util/webapi.common';
import {listaEquivalenciaPesquisa } from '@common/util/api-common.util';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import { retornaEtapaFormatada, retornaStatusFormatado, retornaFiltroFormatado } from '@common/util/defaultValues';
import FiltroContainer from '../filtros/filtro.container';
import { injectIntl, useIntl } from 'react-intl';

function PesquisaCommonContainer (props) {
  const intl = useIntl()
  const dispatch = useDispatch();
  const {messages}=props.intl;

  const filtros = useSelector(state => state.commonReducer.filtros);
  const ordenacao = useSelector(state => state.commonReducer.ordenacao);
  const favoritos = useSelector(state => state.commonReducer.favoritos);
  const grupoUsuarios = useSelector(state => state.commonReducer.grupoUsuario);
  const filtrosExterno = useSelector(state => state.commonReducer.filtrosExterno);
  const [selecionados, setSelecionados] = useState([]);
  const [paginaCarregada, setPaginaCarregada] = useState(0);
  const [showLoading, setShowLoading] = useState(false);
  const [totalItens, setTotalItens] = useState(0);
  const [currentLang, setCurrentLang] = useState();

  const lang = useSelector(state => state.commonReducer.lang);

  useEffect(() => {
    const usuarioLocalStorage = getUsuarioLocalStorage();
    if (
      usuarioLocalStorage === null ||
      usuarioLocalStorage.usuarioId === undefined
      ) {
        window.location.href = '/login';
      } else {
        if (!favoritos.length) {
          loadItens(usuarioLocalStorage);
        }
      }

      if (!!props.listagem.length) {
        const listaFormatada = formataListagem(props.listagem);
        dispatch(actions.preencherListagem(listaFormatada));
      }

      if(currentLang && currentLang !== lang){
        loadItens(usuarioLocalStorage);
        const listaFormatada = formataListagem(props.listagem);
        dispatch(actions.preencherListagem(listaFormatada));
      }
      setCurrentLang(lang);
  }, [lang]);

  useEffect(()=>{
    if(filtrosExterno  && filtrosExterno.filtrosExterno && filtrosExterno.filtrosExterno.length > 0){
      dispatch(actionsFiltros.filtrosSelecionados(filtrosExterno.filtrosExterno));
      filtrar(filtrosExterno.filtrosExterno, 0);
    }

  },[filtrosExterno])


  const loadItens = usuarioLocalStorage => {
    Promise.all([
      WebapiCommon.getFiltros(usuarioLocalStorage.usuarioId),
      WebapiCommon.getFiltrosFavoritosUsuario(usuarioLocalStorage.usuarioId),
      WebapiCommon.getGrupoUsuarios()
    ]).then(responseArray => {
      const [
        respFiltros,
        respFiltrosFavoritosUsuario,
        respGrupoUsuarios
      ] = responseArray;
      const newRespFiltros = retornaFiltroFormatado(respFiltros, messages);
      dispatch(actions.preencherFiltro(newRespFiltros));
      dispatch(actions.preencherFavoritos(respFiltrosFavoritosUsuario));
      dispatch(actions.preencherGrupoUsuario(respGrupoUsuarios));
    });
  };

  const filtrarfavorito = filtroId => {
    dispatch(actionsFiltros.filtrosSelecionados([]));
    WebapiCommon.getFiltroFavorito(filtroId).then(filtro => {
      dispatch(actions.preencherFiltro(filtro));
    });
  };

  const preencherOrdenacao = (ordemID, sentido) => {
    dispatch(actions.preencherOrdenacao(ordemID, sentido));
  };

  const formataListagem = listagem => {
    return listagem.map(itemLaudo => ({
      ...itemLaudo,
      etapas: itemLaudo.etapas.map(itemEtapa => ({
        ...itemEtapa,
        statusFormatado: retornaStatusFormatado(itemEtapa.status, messages),
        etapaFormatada: retornaEtapaFormatada(itemEtapa.etapa, messages),
      }))
    }));
  };

  const filtrar = (selecionadosParam, pagina, reload = false) => {
    let lista = props.listagem;
    let paginaCarregadaAnterior = paginaCarregada;

    if (selecionados !== selecionadosParam || reload) {
      dispatch(actions.preencherListagem([]));
      dispatch(actions.avancarPaginaListagem(1));
      paginaCarregadaAnterior = 0;
      lista = [];
      pagina = 1;
      setSelecionados(selecionadosParam);
    }

    if (
      selecionadosParam.length === 1 &&
      selecionadosParam[0].param === 'Observação do Laudo'
    ) {
      const message = 'Informe ao menos dois filtros para essa pesquisa';
      dispatch(actions.showAlerta('erro', message, 3000, '450px'));
    } else if (selecionadosParam.length === 0) {
      dispatch(actions.preencherListagem(lista));
      dispatch(actions.atualizarNumeroRegistros(0, 0));
      const message = intl.formatMessage({id:"message.noExamFound"})
      return dispatch(actions.showAlerta('alerta', message, 1500));
    } else {
      if (pagina > paginaCarregadaAnterior) {
        setPaginaCarregada(pagina);
        if (pagina === 1) {
          showFadeCarregando(true);
          dispatch(actions.closeCarregando(true));
        } else if (paginaCarregadaAnterior > 1) {
          setShowLoading(true);
        }

        const paramStatusEtapa = 'Status da etapa';
        if (
          selecionadosParam.findIndex(el => el.param === paramStatusEtapa) > -1
        ) {
          let selecionadosSemStatus = selecionadosParam.filter(
            el => el.param !== paramStatusEtapa
          );
          let selecionadosComStatus = selecionadosParam.filter(
            el => el.param === paramStatusEtapa
          );
          let status = '';

          for (let i = 0; i < selecionadosComStatus.length; i++) {
            const element = selecionadosComStatus[i];
            status +=
              element.value + (selecionadosComStatus.length - 1 > i ? '|' : '');
          }

          selecionadosSemStatus.push({
            id: 22,
            value: status,
            param: paramStatusEtapa
          });

          selecionadosParam = selecionadosSemStatus;
        }

        WebapiCommon.getListagem(selecionadosParam, pagina, ordenacao).then(
          response => {
            const responseLista = formataListagem(response.listagem);
            lista = lista.concat(responseLista);

            dispatch(actions.preencherListagem(lista));
            if (pagina === 1) {
              setTotalItens(response.total);
              dispatch(
                actions.atualizarNumeroRegistros(lista.length, response.total)
              );
            } else {
              dispatch(
                actions.atualizarNumeroRegistros(lista.length, totalItens)
              );
            }

            showFadeCarregando(false);
            dispatch(actions.closeCarregando(false));
            dispatch(actions.loadListagem(false));

            if (paginaCarregada > 1) {
              setShowLoading(false);
            }

            if (pagina === 1) {
              if (lista.length === 0) {
                const message = intl.formatMessage({id:"message.noExamFound"})
                dispatch(actions.showAlerta('alerta', message, 1500));
              } else {
                const message = intl.formatMessage({id:"message.examFound"})
                dispatch(actions.showAlerta('sucesso', message, 1500));
              }
            }
          }
        );
      }
    }
  };

  const showFadeCarregando = exibir => {
    dispatch(actions.showFadeCarregando(exibir));
  };

  return (
    <FiltroContainer
      intl={intl}
      filtros={filtros}
      favoritos={favoritos}
      filtrar={filtrar}
      filtrarfavorito={filtrarfavorito}
      setOrdenacao={preencherOrdenacao}
      carregando={showFadeCarregando}
      listagemExibido={props.listagemExibido}
      listagemTotal={props.listagemTotal}
      pagina={props.pagina}
      grupoUsuarios={grupoUsuarios}
      showLoading={showLoading}
    />
  );
}

export default injectIntl(PesquisaCommonContainer);



// WEBPACK FOOTER //
// ./src/pages/main/pesquisa/pesquisa-common.container.js